import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.trading_data.linked_accounts.title',
        defaultMessage: 'Linked Accounts'
    },
    unlinkedError: {
        id: '_.trading_data.linked_accounts.unlinked_error',
        defaultMessage: 'Please relink your account so you don’t fall behind'
    },
    unlink: {
        id: '_.trading_data.linked_accounts.unlink',
        defaultMessage: 'Unlink'
    }
});
